import { isProblemError, isTransportError, isValidationError } from '@volee/api-client'

import { NETWORK_ERROR, UNKNOWN_ERROR, translateError } from './errors.ts'
import { translateFieldError } from './field-errors.ts'

/*
 * The bridge between an error thrown by @volee/api-client and the text on screen.
 *
 * It exists because the guardrail "never show `title`/`detail` to a user" needs exactly one
 * place that honours it: if every component built the message itself, sooner or later one of
 * them would read `error.detail` because it is the nearest string to hand. In here `detail` is
 * not even read.
 */

export { NETWORK_ERROR }

/**
 * The message for any error at all, in the active language.
 *
 * A 422 uses the first rejected field: a toast needs one sentence, and the per-field binding
 * is the form's job, through `byField()`.
 */
export function errorMessage(error: unknown): string {
  if (isValidationError(error)) {
    const first = error.fields[0]
    return first === undefined
      ? translateError(error.code, error.params)
      : translateFieldError(first)
  }
  if (isProblemError(error)) {
    return translateError(error.code, error.params)
  }
  if (isTransportError(error)) {
    return NETWORK_ERROR
  }
  return UNKNOWN_ERROR
}
